import React from 'react';
import { Portlet as LibPortlet } from 'vdlib';
import { history } from 'data/Store';

const Portlet = ({ children, ...props }) => (
  <LibPortlet history={history} {...props}>
    {children}
  </LibPortlet>
);

export default Portlet;
